import { render } from "./cfText.vue?vue&type=template&id=6b8d33ee&scoped=true&ts=true"
import script from "./cfText.vue?vue&type=script&lang=ts"
export * from "./cfText.vue?vue&type=script&lang=ts"

import "./cfText.vue?vue&type=style&index=0&id=6b8d33ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8d33ee"]])

export default __exports__